import React, { HTMLAttributes } from 'react';

const TransparentButton = (properties: HTMLAttributes<HTMLButtonElement>) => {
  const { children, className, ...remainingProperties } = properties;
  return (
    <button
      {...remainingProperties}
      className={`text-theme-white border-solid border-[thin] border-theme-white font-bold tracking-wider uppercase text-xs py-[0.45rem] px-4 rounded-[0.25rem] ${className}`}
    >
      {children}
    </button>
  );
};

export default TransparentButton;
